import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to support and challenge in tandem.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">
                                            <img
                                                src={require('@images/tandem_img.png')}
                                                alt="" className="tendemimg"/>
                                            <div className="textalignTarea extrapaddingtable"></div>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <div className=""><p>What makes us want to get out there and
                                                make a difference? Take these people… what do they need to
                                                make them dynamic and go-getting rather than bored and
                                                uninterested?</p></div>

                                            <div className="border_subtitle">Knowing when to support and
                                                when to challenge
                                            </div>
                                            <p>How do you manage staff so that they perform to the best of
                                                their abilities? Effective motivation depends on many
                                                factors such as pay, job structure and work conditions. One
                                                factor that seems to outweigh all others, however, is the
                                                degree to which you can positively affect people’s levels of
                                                attention and interest in what they’re doing, as
                                                demonstrated in the following research into behaviour at
                                                work.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Are you paying attention?
                                                </div>
                                                <p>Several years back, researchers conducted a study into
                                                    whether paying attention or ‘mindfulness’ had a positive
                                                    impact on stress and health behaviours<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>1</sup></a>.
                                                    Hundreds of undergraduates were studied on their
                                                    behaviours regarding paying attention, their stress
                                                    levels and their adherence to health-related behaviours
                                                    such as eating fruit &amp; vegetables, and exercise.</p>
                                                <p>Those who had a tendency to ‘drift off’ and paid less
                                                    attention during their everyday lives were surprisingly
                                                    found to be more stressed overall. Additionally, those
                                                    who were more mindful were more likely to engage in
                                                    healthy behaviours and have a more positive outlook.</p>
                                                <div className="uiheading"><p>It just shows that if you’re
                                                    feeling like your mind wants to drift off during a
                                                    meeting or when doing the chores, keep with it, it’s
                                                    good for you!</p></div>
                                            </div>


                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Getting people to pay attention is just one of the good
                                                possible outcomes of successfully supporting and
                                                challenging. However, it is important to interplay these two
                                                tactics, so you are not making yourself obstructive, or a
                                                push-over. This tool is designed to <span
                                                    className="brown brownbold">help you get this balance  right</span> and
                                                make the most out of your leadership by directing and
                                                motivating your employees.</p>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}